import type { LanguageEnumDto } from "@core/data/dto/language.dto";
import { LanguageEnumDtoSchema } from "@core/data/dto/language.dto";
import * as z from "zod";

export interface LanguageUpdateCurrentBody {
    locale: LanguageEnumDto;
}

export const CurrentLanguageDtoSchema = z
    .object({
        locale: LanguageEnumDtoSchema.readonly(),
    })
    .readonly();

export type CurrentLanguageDto = z.output<typeof CurrentLanguageDtoSchema>;
